import React from 'react';
import { FadeIn } from '../FadeIn';
import { Check, Headphones } from 'lucide-react';
export function ModulesAHA() {
  const lessons = [{
    number: 'LECȚIA 1',
    title: 'De ce te copleșesc emoțiile',
    points: ['Înțelegi de ce corpul tău reacționează uneori înainte să apuci să gândești', 'Vezi emoțiile nu ca pe niște dușmani, ci ca pe mesageri care îți spun ceva important', 'Primul exercițiu de journaling care te ajută să identifici emoția care te ia cel mai des prin surprindere']
  }, {
    number: 'LECȚIA 2',
    title: 'Respirația de ancorare',
    points: ['Înveți tehnica de respirație 4-2-6 pe care o poți folosi oriunde, în 30 de secunde', 'Trimiți corpului tău mesajul „sunt în siguranță” chiar și când mintea o ia razna', 'Audio ghidat pe care îl poți reasculta ori de câte ori ai nevoie']
  }, {
    number: 'LECȚIA 3',
    title: 'Respirația de eliberare',
    points: ['Înveți să descarci furia și tensiunea fără să rănești pe nimeni, inclusiv pe tine', 'Înțelegi de ce furia blocată se transformă în dureri de cap, insomnii sau izbucniri', 'Tehnica 5-6 cu expirație puternică, explicată pas cu pas']
  }, {
    number: 'LECȚIA 4',
    title: 'Respirația de întoarcere',
    points: ['Ieși din amorțeală și deconectare, chiar și în zilele când simți că te uiți la viața ta de departe', 'Înveți tehnica 5-4-3-2-1 pentru a reveni rapid în prezent și în corp', 'Primul pas blând de ieșire din disociere, fără să forțezi nimic']
  }, {
    number: 'LECȚIA 5',
    title: 'Cele 3 tehnici de reglare emoțională',
    points: ['Ancorarea în prezent prin cele 5 simțuri, numirea emoției și mișcarea ca descărcare', 'Fișa personală „Momentul Cicatricii” pentru a lucra cu tiparele care se repetă', 'Fișa „Kitul meu de urgență emoțională” pe care o completezi acum și o folosești când ai nevoie']
  }];
  return <section id="module" className="py-20 md:py-28 bg-ivory relative overflow-hidden" data-id="element-203">
      <div className="max-w-[1000px] mx-auto px-6 md:px-8 relative z-10" data-id="element-204">
        <div className="text-center mb-16" data-id="element-205">
          <FadeIn data-id="element-206">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-medium text-forest mb-6" data-id="element-207">
              Cele 5 module ale cursului
            </h2>
          </FadeIn>
        </div>

        <div className="space-y-8" data-id="element-208">
          {lessons.map((lesson, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-209">
              <div className="bg-white border border-gold/30 rounded-[24px] p-8 md:p-10 shadow-soft hover:shadow-lg transition-shadow duration-300 relative overflow-hidden group" data-id="element-210">
                <div className="absolute -right-4 -top-8 text-[120px] font-serif font-bold text-gold/5 group-hover:text-gold/10 transition-colors duration-300 pointer-events-none" data-id="element-211">
                  {index + 1}
                </div>

                <div className="flex flex-col md:flex-row gap-6 md:gap-12 relative z-10" data-id="element-212">
                  <div className="md:w-1/3 shrink-0" data-id="element-213">
                    <div className="inline-flex items-center gap-2 border border-forest/20 rounded-full px-4 py-1 mb-4 bg-forest/5" data-id="element-214">
                      <Headphones className="w-3.5 h-3.5 text-forest" data-id="element-215" />
                      <span className="font-display text-xs font-semibold tracking-wider text-forest uppercase" data-id="element-216">
                        {lesson.number}
                      </span>
                    </div>
                    <h3 className="text-2xl font-serif font-medium text-forest" data-id="element-217">
                      {lesson.title}
                    </h3>
                  </div>

                  <div className="md:w-2/3" data-id="element-218">
                    <ul className="space-y-4" data-id="element-219">
                      {lesson.points.map((point, ptIndex) => <li key={ptIndex} className="flex items-start gap-4" data-id="element-220">
                          <div className="w-6 h-6 rounded-full bg-gold/20 flex items-center justify-center shrink-0 mt-1" data-id="element-221">
                            <Check className="w-3.5 h-3.5 text-gold-dark" strokeWidth={3} data-id="element-222" />
                          </div>
                          <p className="text-[18px] text-charcoal/70 leading-relaxed" data-id="element-223">
                            {point}
                          </p>
                        </li>)}
                    </ul>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}